import React, { useRef } from "react";
import { Box, Button } from "@mui/material";
import { useParams, useSearchParams, useNavigate, useLocation, } from "react-router-dom";
import { PageHeader } from "@ui/components/header/PageHeader";
import { ForecastTableContent, } from "./ForecastTableContent";
export const ForecastAdjustPage = () => {
    var _a;
    const { projectId } = useParams();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const location = useLocation();
    const topProjectNumber = searchParams.get("topProjectNumber") || "";
    const entityName = searchParams.get("entityName") || "";
    const companyId = searchParams.get("companyId") || "";
    const childProjectNumber = searchParams.get("childProjectNumber") || topProjectNumber;
    const projectName = ((_a = location.state) === null || _a === void 0 ? void 0 : _a.projectName) ||
        (topProjectNumber && entityName
            ? `${topProjectNumber}: ${entityName}`
            : topProjectNumber);
    const contentRef = useRef(null);
    const buildDetailsSearch = () => {
        const params = new URLSearchParams();
        if (topProjectNumber)
            params.set("topProjectNumber", topProjectNumber);
        if (entityName)
            params.set("entityName", entityName);
        if (companyId)
            params.set("companyId", companyId);
        const aanneemsom = searchParams.get("aanneemsom");
        if (aanneemsom)
            params.set("aanneemsom", aanneemsom);
        if (childProjectNumber && childProjectNumber !== topProjectNumber) {
            params.set("childProjectNumber", childProjectNumber);
        }
        return params.toString();
    };
    const handleBack = () => {
        if (projectId) {
            const qs = buildDetailsSearch();
            navigate(`/project/${projectId}/details${qs ? `?${qs}` : ""}`, {
                replace: true,
            });
        }
        else {
            navigate(-1);
        }
    };
    const handleSave = () => {
        var _a;
        (_a = contentRef.current) === null || _a === void 0 ? void 0 : _a.save();
    };
    const detailsQuery = buildDetailsSearch();
    const detailsPath = projectId
        ? `/project/${projectId}/details${detailsQuery ? `?${detailsQuery}` : ""}`
        : undefined;
    const breadcrumbs = [
        { label: "Projecten", path: "/project" },
        {
            label: `(${projectName || "Project"})`,
            path: detailsPath,
        },
        { label: "Forecast aanpassen" },
    ];
    return (React.createElement(Box, null,
        React.createElement(PageHeader, { title: "Forecast aanpassen", onBack: handleBack, breadcrumbs: breadcrumbs, actions: React.createElement(Box, { display: "flex", gap: 1.5 },
                React.createElement(Button, { variant: "outlined", color: "tertiary", size: "medium", onClick: handleBack }, "Annuleren"),
                React.createElement(Button, { variant: "contained", color: "tertiary", size: "medium", onClick: handleSave }, "Cijfers opslaan")) }),
        React.createElement(Box, { sx: {
                flex: 1,
                overflow: "auto",
                pt: 1,
                pb: 1,
                maxHeight: "calc(100vh - 230px)",
            } }, projectId && topProjectNumber && companyId && (React.createElement(ForecastTableContent, { ref: contentRef, projectId: projectId, projectNumber: topProjectNumber, childProjectNumber: childProjectNumber || undefined, companyId: companyId, onSaved: handleBack, showPlusButtons: true })))));
};
